export default "__VITE_ASSET__wqWbEQawX3YD7lq5X8wRQw__"